import "./PageVolunteer.css";
import VolunteerInterestRequest from "./volunteerInterestRequest";
import Bold from "../style/styleBold";
import { Helmet } from "react-helmet-async";

const PageVolunteer = () => {
  return (
    <>
      <Helmet>
        <title>Volunteer with BCGAP</title>
        <meta
          name="description"
          content="Volunteer with the Bent Christy Graduate Assistance Program and help eliminate college loan debt through fundraising, leadership, and community service."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://bcgap.org/#organization",
                name: "Bent Christy Graduate Assistance Program",
                alternateName: "BCGAP",
                url: "https://bcgap.org",
                nonprofitStatus: "Nonprofit501c3",
              },
              {
                "@type": "VolunteerOpportunity",
                name: "Volunteer with Bent Christy Graduate Assistance Program",
                description:
                  "Volunteer opportunities with the Bent Christy Graduate Assistance Program, including fundraising, board service, grant writing, and other roles.",
                provider: {
                  "@id": "https://bcgap.org/#organization",
                },
                audience: {
                  "@type": "Audience",
                  audienceType: "Volunteers",
                },
                areaServed: "US",
                url: "https://bcgap.org/bent-christy-graduate-assistance-program-volunteer-opportunities",
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="volunteer-section">
        <div className="wrapper-left">
          <div className="volunteer-header">Volunteer with us!</div>
          <div className="image-wrapper">
            <img
              src="./images/volunteering/image-vol.webp"
              alt="Volunter with BCGAP"
            />
          </div>
          <div className="volunteer-content">
            {" "}
            <ul>
              <li>fundraiser</li>
              <li>board member</li>
              <li>grant application writer</li>
              <li class="other-li">
                {" "}
                <Bold>... and other roles!</Bold>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapper-right">
          <VolunteerInterestRequest />
        </div>
      </div>
    </>
  );
};

export default PageVolunteer;
